/**
 * Courbe compacte d'un niveau /5 dans le temps (photos hebdo).
 *
 * Une seule échelle (0–5), la cible en pointillés, le dernier point marqué.
 * Sans donnée : rien — une courbe vide n'apprend rien et prend de la place.
 */
export function Sparkline({ points, target, width = 220, height = 48, color = "#1E7A3C", targetColor = "#7CBF94", ariaLabel }: {
  points: { week: string; level: number }[];
  target?: number | null;
  width?: number; height?: number; color?: string; targetColor?: string; ariaLabel?: string;
}) {
  if (points.length < 2) return null;
  const pad = 4;
  const w = width - pad * 2, h = height - pad * 2;
  const x = (i: number) => pad + (i / (points.length - 1)) * w;
  const y = (v: number) => pad + h - (Math.max(0, Math.min(5, v)) / 5) * h;
  const d = points.map((p, i) => `${i === 0 ? "M" : "L"}${x(i).toFixed(1)},${y(p.level).toFixed(1)}`).join(" ");
  const last = points[points.length - 1]!;
  const first = points[0]!;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} role="img" aria-label={ariaLabel ?? `${first.level} → ${last.level}`} style={{ display: "block", maxWidth: "100%" }}>
      <line x1={pad} x2={width - pad} y1={y(2.5)} y2={y(2.5)} stroke="#EEEDF3" strokeWidth="1" />
      {target != null && <line x1={pad} x2={width - pad} y1={y(target)} y2={y(target)} stroke={targetColor} strokeWidth="1.5" strokeDasharray="4 3" />}
      <path d={`${d} L${x(points.length - 1).toFixed(1)},${(height - pad).toFixed(1)} L${pad},${(height - pad).toFixed(1)} Z`} fill={color} opacity="0.12" />
      <path d={d} fill="none" stroke={color} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={x(points.length - 1)} cy={y(last.level)} r="3.5" fill={color} stroke="#fff" strokeWidth="1.5" />
    </svg>
  );
}
